const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量高清片源',
    desc: '覆盖热播电视剧、院线大片、人气综艺、经典动漫，全网优质高清影视资源一网打尽，每日同步更新不再错过精彩。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '智能多线路调度技术自动匹配最优播放节点，无论4G还是WiFi环境下都能享受零等待流畅观看体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '全程无弹窗广告干扰，不收集用户隐私信息。专注观影体验，让你安心享受每一部精彩影片。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步追剧',
    desc: '支持手机、平板、电脑多设备无缝切换。观影记录云端同步，随时随地接续上次播放进度。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">平台优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">为什么千万用户选择91影视看片app作为首选追剧平台</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, i) => (
            <div key={i} className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}